import cn from 'classnames';
import { iconStyles } from './iconStyles';
import { IconProps } from 'components/Shared/Icon/index';

export const IconPlus = (props: IconProps) => (
  <svg className={cn(iconStyles(props))} width="11" height="11" viewBox="0 0 11 11">
    <path
      d="M1 5.5h9M5.5 1v9"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
